import type { StageRequirement } from '@/features/contract/gating/types'
import { Badge } from './Badge'

/** Pojedynczy warunek publikacji aneksu z etykietą rodzaju i przyciskiem usuwania. */
export function AnnexRequirementRow({ req, onDelete }: { req: StageRequirement; onDelete: () => void }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="text-xs">
        {req.kind === 'STATUS' && (
          <>
            <Badge color="sky" label="STATUS" />
            <span className="font-medium">{req.trackLabelPl}</span>
            <span className="text-slate-400 mx-2">=</span>
            <span>{req.requiredValueLabelPl}</span>
          </>
        )}
        {req.kind === 'DOCUMENT' && (
          <>
            <Badge color="amber" label="DOK" />
            <span className="font-medium">{req.documentTypeLabelPl ?? req.documentTypeCode}</span>
            <span className="text-slate-400 ml-2">załączony</span>
          </>
        )}
        {req.kind === 'FIELD' && (
          <>
            <Badge color="emerald" label="POLE" />
            <span className="font-medium">{req.fieldLabelPl ?? req.fieldCode}</span>
            <span className="text-slate-400 ml-2">wypełnione</span>
          </>
        )}
      </div>
      <button onClick={onDelete} className="text-[10px] text-red-600">Usuń</button>
    </div>
  )
}
